export default __webpack_public_path__ + "static/f91130bf0271174362ba8d3f6894f3dc.jpg";